import * as React from 'react';
import styles from './index.less';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import FModal from '@/components/FModal';
import fMessage from '@/components/fMessage';
import * as AHooks from 'ahooks';
import FInput_PinyinSafeTextCounter from '@/components/FInput_PinyinSafeTextCounter';

interface FCreateBucketModalProps {
  onOk?(value: string): void;

  onClose?(): void;
}

function FCreateBucketModal({ onOk, onClose }: FCreateBucketModalProps) {
  const [$visible, set$visible, get$visible] = FUtil.Hook.useGetState<boolean>(true);
  const [$newBucketName, set$newBucketName, get$newBucketName] = FUtil.Hook.useGetState<string>('');
  const [$newBucketNameError, set$newBucketNameError, get$newBucketNameError] =
    FUtil.Hook.useGetState<string>('');

  const { run } = AHooks.useDebounceFn(
    async () => {
      if (get$newBucketNameError() !== '') {
        return;
      }

      const params: Parameters<typeof FServiceAPI.Storage.bucketIsExist>[0] = {
        bucketName: get$newBucketName(),
      };
      const { ret, errCode, data, msg } = await FServiceAPI.Storage.bucketIsExist(params);
      if (data) {
        set$newBucketNameError(FI18n.i18nNext.tAuto('bucket_createbucket_err_notavailable'));
        return;
      }

      set$newBucketNameError('');
    },
    {
      wait: 300,
    },
  );

  return (
    <FModal
      title={null}
      open={$visible}
      width={640}
      okButtonProps={{
        disabled: $newBucketName === '' || $newBucketNameError !== '',
      }}
      okText={FI18n.i18nNext.tAuto('btn_done')}
      cancelText={FI18n.i18nNext.tAuto('btn_cancel')}
      onOk={async () => {
        const params: Parameters<typeof FServiceAPI.Storage.createBucket>[0] = {
          bucketName: get$newBucketName(),
        };
        const { ret, errCode, msg } = await FServiceAPI.Storage.createBucket(params);

        if (ret !== 0 || errCode !== 0) {
          fMessage(msg, 'error');
          return;
        }
        onOk && onOk(get$newBucketName());
        set$visible(false);
      }}
      onCancel={() => {
        set$visible(false);
      }}
      afterClose={() => {
        onClose && onClose();
      }}
    >
      <div style={{ padding: 20 }}>
        <FComponentsLib.FTitleText
          text={
            // 创建存储空间
            FI18n.i18nNext.tAuto('create_bucket_popup_title')
          }
          type='h2'
        />
      </div>

      <div className={styles.FModalBody}>
        <div style={{ height: 50 }} />
        <div className={styles.tip}>
          {
            FI18n.i18nNext.tJSXElement('create_bucket_popup_msg')
            // .split('\n')
            // .map((s, i) => {
            //   return <div key={i}>{s}</div>;
            // })
          }
        </div>
        <div style={{ height: 10 }} />
        {/* <FComponentsLib.FInput.FSingleLine */}
        <FInput_PinyinSafeTextCounter
          lengthLimit={-1}
          value={$newBucketName}
          placeholder={FI18n.i18nNext.t('enter_bucket_name')}
          onChangeValue={(v) => {
            let error: string = '';
            if (!FUtil.Regexp.BUCKET_NAME.test(v)) {
              // set$newBucketNameError(FI18n.i18nNext.tAuto('naming_convention_bucket_name'));
              // return;
              error = FI18n.i18nNext.tAuto('naming_convention_bucket_name');
            }
            set$newBucketName(v);
            set$newBucketNameError(error);
            run();
          }}
          className={styles.FInput}
        />
        <div style={{ height: 10 }} />
        <div className={styles.errorTip}>
          {$newBucketNameError ? (
            <div>
              {
                // FI18n.i18nNext.tAuto('naming_convention_bucket_name')
                $newBucketNameError.split('\n').map((s, i) => {
                  return <div key={i}>{s}</div>;
                })
              }
            </div>
          ) : (
            ''
          )}
        </div>
        <div style={{ height: 50 }} />
      </div>
    </FModal>
  );
}

export default FCreateBucketModal;
